<script>
    import { buyGems } from "commerce/stores/buyGems";

    import { loadQuotes } from "lib/load-quotes";

    import { disableButtons, dim } from "stores/toggles";
    import { activeQuote }         from "stores/active-quote";

    import Balance from "components/balance/balance.svelte";
    import Quotes  from "components/quotes/quotes.svelte";
    import Footer  from "components/footer/footer.svelte";
    import Prompt  from "components/prompt/prompt.svelte";

    import Embed from "commerce/embed/embed.svelte";

    import css from "./exchange.css";

    const i18n = window.strings.exchange;
</script>

{#await loadQuotes()}
<!-- empty until load -->
{:then}
<div class="{css.exchange}" data-disableButtons={$disableButtons}>
    <Prompt />

    {#if $buyGems}
        <Embed type="gems" />
    {/if}

    <Balance />

    <div class="{`hbox ${css.exchangeBody} ${$dim ? css.dim : ""}`}" data-dim={$dim}>
        <Quotes />

        <!-- These come after so that sibling selectors can be used for a highlight -->
        <h1 class="{css.goldTitle}" data-coinsQuote={$activeQuote.type === "coins"}>
            {i18n.gems2gold.title}
        </h1>

        <h1 class="{css.gemsTitle}" data-gemsQuote={$activeQuote.type === "gems"}>
            {i18n.gold2gems.title}
        </h1>
    </div>

    <Footer />
</div>
{/await}
